import { module } from 'modujs';
import debounce from 'lodash.debounce';
import Slideout from './Slideout';
import { lazyLoadImage } from '../utils/image';

export default class extends Slideout {
    constructor(m) {
        super(m);
        this.input = this.$('input')[0];
    }

    init() {
      const inputdebounce = debounce(this.inputChange.bind(this), 1500);
      this.input.addEventListener("keyup", inputdebounce);
    }

    inputChange(event) {
      let lazyImages = this.el.querySelectorAll('[data-lazyload]');

      if(lazyImages) {
        console.log(lazyImages)
        lazyImages.forEach((el) => {
          lazyLoadImage(el, null, () => {
            //callback
          })
        })
      }
    }
}
